export const wordsList = [
  {
    value: '方便发一份你的简历过来么？',
  },
  {
    value: '什么时候方便过来面试啊？',
  },
  {
    value: '对不起，看了你的简历以后觉得不太合适，希望你早日找到心仪的工作。',
  },
  {
    value: '你好，请问你还在找工作么？',
  },
  // {
  //   value: '糟糕！是心动的感觉！',
  // },
  // {
  //   value: '心疼地抱抱自己，我太难了！',
  // },
  // {
  //   value: '没关系，别在意，事情过去就过去了。',
  // },
  // {
  //   value: '早上好，今天也是让人期待的一天呢！',
  // },
  // {
  //   value: '熬夜有什么用，又没人陪你聊天，早点休息吧。',
  // },
];
